<template>
  <div class="app-container">
    <el-dialog title="在线添加联系人" width="70%" center :close-on-click-modal="false" :visible.sync="showDialog"
      @close="setDialogClosed" append-to-body>
      <el-container direction="vertical">
        <el-row>
          <el-form :inline="true" style="margin-top: 0px" v-loading="formLoading" size="mini">
            <el-form-item label="姓名">
              <el-input v-model="listQuery.name"></el-input>
            </el-form-item>
            <el-form-item label="身份证号" style="margin-left: 20px;">
              <el-input v-model="listQuery.idcard"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button style="margin-left: 20px;" type="primary" @click="submitForm">查询</el-button>
            </el-form-item>
          </el-form>
        </el-row>

        <el-row style="margin-top: 10px;">
          <el-table size="small" height="300px" v-loading="listLoading" :data="list" border fit highlight-current-row
            style="width: 100%; margin-left: 0px;overflow:auto;">
            <el-table-column align="center" label="姓名" width="100">
              <template slot-scope="scope">
                <span>{{ scope.row.name }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="性别" width="60">
              <template slot-scope="scope">
                <span>{{ getGender(scope.row.gender) }}</span>
              </template>
            </el-table-column>

            <el-table-column align="center" label="出生年月">
              <template slot-scope="scope">
                <span>{{ scope.row.birthday }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="年龄" width="60">
              <template slot-scope="scope">
                <span>{{ getAge(scope.row.birthday) }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="电话号码">
              <template slot-scope="scope">
                <span>{{ scope.row.phone }}</span>
              </template>
            </el-table-column>

            <el-table-column width="170px" align="center" label="身份证号">
              <template slot-scope="scope">
                <span>{{ scope.row.idcard }}</span>
              </template>
            </el-table-column>

            <el-table-column align="center" label="所属机构">
              <template slot-scope="scope">
                <span>{{ scope.row.managerHospital }}</span>
              </template>
            </el-table-column>

            <el-table-column align="center" label="标签">
              <template slot-scope="scope">
                <span :class="scope.row.label1">压</span>
                <span :class="scope.row.label2">脂</span>
                <span :class="scope.row.label3">糖</span>
                <span :class="scope.row.label4">糖易</span>
              </template>
            </el-table-column>

            <el-table-column align="center" label="操作">
              <template slot-scope="scope">
                <el-button @click="addHomePatient(scope.row)" type="text">
                  添加联系人
                </el-button>
                <show-home-patient @updateHomeList="updateHomeList" ref="showHomePatientRef"
                  v-if="showHomePatientVisiable"></show-home-patient>
              </template>
            </el-table-column>
          </el-table>
        </el-row>
      </el-container>

      <pagination v-show="total > 0" :total="total" :page.sync="listQuery.pageNum" :limit.sync="listQuery.pageSize"
        @pagination="turnToPage" />

      <show-home-patient @updateHomeList="updateHomeList" ref="showHomePatientRef"
        v-if="showHomePatientVisiable"></show-home-patient>
    </el-dialog>
  </div>
</template>
<script>
import {
  getAllSearchList,
  turnToPageList,
  getSysDicList
} from "@/api/health/Patients";
import Pagination from "@/components/Pagination";
import SelectTree from '@/components/selectTree';
import ShowHomePatient from './showHomePatient.vue';

export default {
  components: { Pagination, SelectTree, ShowHomePatient },
  // props: {
  //   pInfo: {
  //     typeof: Object,
  //     default: {}
  //   }
  // },
  data() {
    return {
      showDialog: false,
      pInfo:null,
      data: [],
      list: null,
      total: 0,
      listLoading: false,
      formLoading: false,
      valueData: null,
      birthdayData: null,
      showHomePatientVisiable: false,
      listQuery: {
        name: null,
        idcard: null,
        pageNum: 0,
        pageSize: 10,
      },
      formData: {
        relationship: null
      },
      managerHospitalList: [],
      sexOptions: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  created() {
    var typeData = "性别";
    this.getSystemDictList(typeData);
    this.submitForm();
  },
  methods: {
    async init(value) {
      this.pInfo = value;
      this.showDialog = true;
    },
    setDialogClosed() {
      this.showDialog = false;
    },
    getSystemDictList(typeName) {
      var typeData = {
        "typeName": typeName
      };
      getSysDicList(typeData).then(res => {
        var records = [];
        if (res.msg == "success") {
          var data = res.data;
          records = data.records;
        }
        this.sexOptions = records;
      }).catch(err => {
        console.log(err);
      })
    },
    getGender(gender) {
      var option = this.sexOptions.filter(v => v.value == gender)[0];
      return option.name;
    },
    // 刷新列表
    updateHomeList() {
      this.$emit("updateHomeList");
    },
    // addHomePatient添加家庭联系人
    addHomePatient(row) {
      this.showHomePatientVisiable = true;
      this.$nextTick(() => {
        this.$refs.showHomePatientRef.init(row,this.pInfo);
      })
    },
    // 获取高血压类名
    setLabel1(value) {
      if (
        value.isBloodpressure == "否" ||
        value.isBloodpressure == null ||
        value.isBloodpressure == ""
      ) {
        this.showLabel1 = false;
        return "labelNone";
      } else {
        this.showLabel1 = true;
        if (
          value.hyerBpRisk == null ||
          value.hyerBpRisk == "0" ||
          value.hyerBpRisk == ""
        ) {
          return "labelGray";
        } else if (value.hyerBpRisk == "1") {
          return "labelGreen";
        } else if (value.hyerBpRisk == "2") {
          return "labelOrange";
        } else if (value.hyerBpRisk == "3") {
          return "labelRed";
        }
      }
    },
    setLabel2(value) {
      if (
        value.isAscvd == "否" ||
        value.isAscvd == null ||
        value.isAscvd == ""
      ) {
        this.showLabel2 = false;
        return "labelNone";
      } else {
        this.showLabel2 = true;
        if (
          value.hyperTcRisk == null ||
          value.hyperTcRisk == "0" ||
          value.hyperTcRisk == ""
        ) {
          return "labelGray";
        } else if (value.hyperTcRisk == "1") {
          return "labelGreen";
        } else if (value.hyperTcRisk == "2") {
          return "labelOrange";
        } else if (value.hyperTcRisk == "3") {
          return "labelRed";
        }
      }
    },
    setLabel3(value) {
      if (
        value.isDiabet == "否" ||
        value.isDiabet == "null" ||
        value.isDiabet == ""
      ) {
        this.showLabel3 = false;
        return "labelNone";
      } else {
        this.showLabel3 = true;
        if (
          value.hyperDiabetesRisk == null ||
          value.hyperDiabetesRisk == "0" ||
          value.hyperDiabetesRisk == ""
        ) {
          return "labelGray";
        } else if (value.hyperDiabetesRisk == "1") {
          return "labelGreen";
        } else if (value.hyperDiabetesRisk == "2") {
          return "labelOrange";
        } else if (value.hyperDiabetesRisk == "3") {
          return "labelRed";
        }
      }
    },
    setLabel4(value) {
      if (value.easyillDiabetes) {
        return "labelPurple";
      } else {
        return "labelNone";
      }
    },
    // 查询健康列表
    submitForm() {
      this.listLoading = true;
      if (this.valueData != null) {
        this.listQuery.createTimeStart = this.getParseDate(this.valueData[0], 1);
        this.listQuery.createTimeEnd = this.getParseDate(this.valueData[1], 2);
      } else {
        this.listQuery.createTimeStart = null;
        this.listQuery.createTimeEnd = null;
      }
      if (this.birthdayData != null) {
        this.listQuery.birthdayStart = this.getParseDate(this.birthdayData[0], 1);
        this.listQuery.birthdayEnd = this.getParseDate(this.birthdayData[1], 2);
      } else {
        this.listQuery.birthdayStart = null;
        this.listQuery.birthdayEnd = null;
      }
      getAllSearchList(this.listQuery).then((res) => {
        this.listLoading = false;
        if (res.msg == "success") {
          this.list = res.data.records;
          this.total = res.data.total;
          this.list.forEach((item, index) => {
            this.list[index].label1 = this.setLabel1(item) ? this.setLabel1(item) : 'labelNone';
            this.list[index].label2 = this.setLabel2(item) ? this.setLabel2(item) : 'labelNone';
            this.list[index].label3 = this.setLabel3(item) ? this.setLabel3(item) : 'labelNone';
            this.list[index].label4 = this.setLabel4(item) ? this.setLabel4(item) : 'labelNone';
          })
        }
      });
    },
    // 导航跳转查询列表页
    turnToPage() {
      this.listLoading = true;
      if (this.valueData != null) {
        this.listQuery.createTimeStart = this.getParseDate(this.valueData[0], 1);
        this.listQuery.createTimeEnd = this.getParseDate(this.valueData[1], 2);
      } else {
        this.listQuery.createTimeStart = null;
        this.listQuery.createTimeEnd = null;
      }
      if (this.birthdayData != null) {
        this.listQuery.birthdayStart = this.getParseDate(this.birthdayData[0], 1);
        this.listQuery.birthdayEnd = this.getParseDate(this.birthdayData[1], 2);
      } else {
        this.listQuery.birthdayStart = null;
        this.listQuery.birthdayEnd = null;
      }

      turnToPageList(this.listQuery).then((res) => {
        this.listLoading = false;
        if (res.msg == "success") {
          this.list = res.data.records;
          this.total = res.data.total;
          this.list.forEach((item, index) => {
            this.list[index].label1 = this.setLabel1(item) ? this.setLabel1(item) : 'labelNone';
            this.list[index].label2 = this.setLabel2(item) ? this.setLabel2(item) : 'labelNone';
            this.list[index].label3 = this.setLabel3(item) ? this.setLabel3(item) : 'labelNone';
            this.list[index].label4 = this.setLabel4(item) ? this.setLabel4(item) : 'labelNone';
          })
        }
      });
    },
    // 日期格式转化
    getParseDate(time, type) {
      if (type == 1) {
        var newTime = new Date(time);
      } else if (type == 2) {
        var newTime = new Date((new Date(time) / 1000 + 86400) * 1000);
      }
      // 获取完整的年份(4位)
      var year = newTime.getFullYear();
      // 获取月份(0-11,0代表1月)
      var month = newTime.getMonth() + 1;
      // 获取日期(1-31)
      var date = newTime.getDate();

      return year + "-" + (month < 10 ? '0' + month : month) + "-" + (date < 10 ? '0' + date : date);
    },
    // 身份证号加密
    formatIDcard(card) {
      if (card == null) return "";

      var str = card;
      str = str.toString().replace(/^(.{3})(?:\w+)(.{4})$/, "$1***********$2");
      return str;
    },
    // 手机号加密
    formatPhone(card) {
      if (card == null) return "";

      var str = card;
      if (str.length == 11) {
        str = str.toString().replace(/^(\d{3})\d{4}(\d{4})$/, "$1****$2");
        return str;
      } else if (str.length == 8) {
        str =
          str.toString().substring(0, 2) + "****" + str.substr(str.length - 2);
        return str;
      } else {
        return str;
      }
    },
    // 计算当前年龄
    getAge(birthday) {
      if (birthday == null) return "";

      var birthdays = new Date(birthday.replace(/-/g, "/"));
      let d = new Date();
      let age =
        d.getFullYear() -
        birthdays.getFullYear() -
        (d.getMonth() < birthdays.getMonth() ||
          (d.getMonth() == birthdays.getMonth() &&
            d.getDate() < birthdays.getDate())
          ? 1
          : 0);
      return age;
    },
  },
};
</script>
<style lang="scss" scoped>
.listQuery {
  display: flex;
  flex-wrap: wrap;
  margin-top: 22px;
}

// .labelRed {
//   border-radius: 50%;
//   color: white;
//   background: red;
//   padding: 3px;
// }

.labelRed {
    height: 24px;
	  width: 24px;
    border-radius: 50%;
    color: white;
    background: red;
    display: inline-block;
}

.labelOrange {
  border-radius: 50%;
  color: white;
  background: orange;
  padding: 3px;
}

.labelGreen {
  border-radius: 50%;
  color: white;
  background: green;
  padding: 3px;
}

.labelGray {
  border-radius: 50%;
  color: white;
  background: gray;
  padding: 3px;
}

.labelPurple {
  border: 1px solid purple;
  background: purple;
  color: #fff;
  padding: 2px;
  border-radius: 50%;
}

.labelNone {
  display: none;
}

// ::v-deep .el-form {

//   .el-input__inner {
//     width: 250px;
//   }
//   .el-input {
//     width: 200px;
//   }

//   .el-date-editor {
//     width: 250px;
//   }

//   .el-form-item__label {
//     width: 140px !important;
//   }

//   .el-form-item:last-child .el-form-item__content {
//     display: flex;
//   }
// }</style>
